import fileField from "../libs/file-field";

export default context => {
    $('.file-input-widget', context).each(function () {
        fileField($(this));
    })
}
